<div *ngIf="configService.confCargadas && !configService.errorConf">
  <router-outlet></router-outlet>
</div>
<div class="container" *ngIf="!configService.confCargadas">
  <div
    class="row justify-content-center align-items-center"
    style="height: 100vh"
  >
    <div *ngIf="!configService.confCargadas && !configService.errorConf">
      <div class="col align-self-center">
        <div class="spinner-grow text-primary" role="status">
          <span class="sr-only">Cargando...</span>
        </div>
      </div>
    </div>

    <div *ngIf="!configService.confCargadas && configService.errorConf">
      <div class="col align-self-center text-center">
        <p>Ha ocurrido un error, por favor reinténtalo.</p>
        <button
          type="button"
          class="btn btn-primary"
          (click)="onClickReintentar()"
        >
          <i class="fas fa-sync-alt"></i> Reintentar
        </button>
      </div>
    </div>
  </div>
</div>
